/**
 * Payroll module routes — moved verbatim from router/index.tsx.
 */

import { type RouteObject } from 'react-router-dom';
import { PK } from '@/constants/permissions';
import { ROUTES } from '@/constants';
import { lazyWithRetry } from '@/utils/lazyWithRetry';
import { PermissionRoute } from '../PermissionRoute';

// Vision v4 Phase 5 — Payroll
const PayrollSummaryPage = lazyWithRetry(() => import('@/features/payroll/pages/PayrollSummaryPage'));

export const payrollRoutes: RouteObject[] = [
      // --------------------------------
      // Payroll Module (Vision v4 Phase 5 Block 11)
      // --------------------------------
      {
        path: ROUTES.payroll.summary,
        element: (
          <PermissionRoute permission={PK.Payroll.View}>
            <PayrollSummaryPage />
          </PermissionRoute>
        ),
      },
];
